import {pathEq} from 'ramda';

import {ApplicationStoreType} from 'reducers';

/**
 * Determines pending status of add to cart
 * @type {SelectorType<boolean>}
 */
export const isPending: (store: ApplicationStoreType) => boolean = pathEq(
    ['cartAdd', 'status'],
    'pending',
);

/**
 * Determines null status of add to cart
 * @type {SelectorType<boolean>}
 */
export const isAddToCartCleared: (store: ApplicationStoreType) => boolean = pathEq(
    ['cartAdd', 'status'],
    null,
);
